// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConnectionDialog_dialogBodyContainer__W4Ztl {
    padding: 0; /* Override the padding 15px of DialogContent, because we need to show border right on the edge */
}

.ConnectionDialog_contentWrapper__MhZzf {
    max-height: 600px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConnectionDialog/ConnectionDialog.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU,EAAE,iGAAiG;AACjH;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".dialogBodyContainer {\n    padding: 0; /* Override the padding 15px of DialogContent, because we need to show border right on the edge */\n}\n\n.contentWrapper {\n    max-height: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogBodyContainer": `ConnectionDialog_dialogBodyContainer__W4Ztl`,
	"contentWrapper": `ConnectionDialog_contentWrapper__MhZzf`
};
export default ___CSS_LOADER_EXPORT___;
